import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useLoja } from './LojaContext';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Store } from 'lucide-react';

export default function LojaLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useLoja();
  const navigate = useNavigate();
  const [search] = useSearchParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Bem-vindo!');
      navigate(search.get('redirect') || '/loja');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Falha no login');
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="text-center mb-6">
        <div className="inline-flex w-16 h-16 bg-gradient-to-br from-fuchsia-500 to-purple-600 rounded-2xl items-center justify-center shadow-lg shadow-fuchsia-500/30 mb-4">
          <Store className="w-8 h-8 text-white" strokeWidth={2.5} />
        </div>
        <h1 className="text-2xl font-black">Entrar na Loja</h1>
        <p className="text-sm text-slate-400">Acesse sua conta MARKIMAGEM</p>
      </div>
      <Card className="bg-slate-900 border-slate-800 p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Email</Label>
            <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="bg-slate-800 border-slate-700" />
          </div>
          <div>
            <Label>Senha</Label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="bg-slate-800 border-slate-700" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-fuchsia-500 hover:bg-fuchsia-600">{loading ? 'Entrando...' : 'Entrar'}</Button>
        </form>
        <p className="text-center text-sm text-slate-400 mt-4">
          Não tem conta? <Link to="/loja/register" className="text-fuchsia-400 hover:text-fuchsia-300">Cadastre-se</Link>
        </p>
      </Card>
    </div>
  );
}
